import BasePerimeter from './base';

export default new BasePerimeter({
    purpose: 'packages',
    govern: {
        'can view': function () {
            return (this.isSuperAdmin() || this.isAdmin())
        },
        'can create': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
        'can changePackageId': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
        'can edit': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
        'can changeTtbCharge': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
        'can exportPackages': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
    }
});
